var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypescript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#494949;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 9javascript-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,44.5V0H89V89H0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.51,44.66v3.62H31.08V81.21h8.21V48.28H50.86V44.72a27.48,27.48,0,0,0-.09-3.67c0-.07-7.05-.09-15.61-.09L19.58,41v3.65l-.07,0Zm52-3.72a10.73,10.73,0,0,1,5.56,3.18A13.85,13.85,0,0,1,79.21,47c0,.13-3.85,2.74-6.19,4.18-.08.07-.44-.31-.8-.89A5.07,5.07,0,0,0,68,47.77c-2.67-.18-4.45,1.22-4.45,3.56A3.49,3.49,0,0,0,64,53c.6,1.23,1.71,2,5.16,3.47,6.37,2.74,9.13,4.54,10.79,7.12a12.94,12.94,0,0,1,1,10.84c-1.42,3.71-4.89,6.23-9.86,7a28,28,0,0,1-6.78-.06,16.83,16.83,0,0,1-9.06-4.74A15.83,15.83,0,0,1,53,73.27l.84-.53,3.34-1.94,2.51-1.47.58.78a12.2,12.2,0,0,0,3.34,3.25c2.89,1.49,6.76,1.29,8.68-.45a3.33,3.33,0,0,0,1.18-2.67A3.45,3.45,0,0,0,72.78,68c-.71-1-2.14-1.78-6.14-3.56-4.61-1.95-6.56-3.2-8.39-5.11a12.69,12.69,0,0,1-2.45-4.45,17.19,17.19,0,0,1-.13-5.72c1-4.45,4.32-7.57,9.12-8.46a21.67,21.67,0,0,1,6.77.23l0,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.6a306b37b580891d4bc58a9deeb4948a.svg";
export { ForwardRef as ReactComponent };